import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from './ui/table';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { formatCurrency, formatNumber } from './promotion-report-format';

export default function PromotionCouponTable({ coupons }) {
  const items = coupons?.items || [];
  const totals = coupons?.totals;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Coupons</CardTitle>
        <p className="text-sm text-muted-foreground">
          Redemptions counts every code entered, cancellations included.
          Discount only adds up the ones still standing.
        </p>

        {totals && (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-4">
            {[
              {
                label: 'Coupons Used',
                value: formatNumber(totals.couponCount),
              },
              {
                label: 'Redemptions',
                value: formatNumber(totals.redemptionCount),
              },
              {
                label: 'Total Discount',
                value: formatCurrency(totals.totalDiscount),
              },
              {
                label: 'Cancelled',
                value: formatNumber(totals.cancelledCount),
              },
            ].map(({ label, value }) => (
              <div key={label} className="rounded-md border bg-muted/30 p-3">
                <div className="text-xs uppercase text-muted-foreground">
                  {label}
                </div>
                <div className="text-lg font-semibold mt-1">{value}</div>
              </div>
            ))}
          </div>
        )}
      </CardHeader>

      <CardContent>
        <div className="border rounded-md overflow-hidden">
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead style={{ padding: '8px 12px' }}>Code</TableHead>
                  <TableHead
                    className="text-right"
                    style={{ padding: '8px 12px' }}
                  >
                    Redemptions
                  </TableHead>
                  <TableHead
                    className="text-right"
                    style={{ padding: '8px 12px' }}
                  >
                    Discount
                  </TableHead>
                  <TableHead
                    className="text-right"
                    style={{ padding: '8px 12px' }}
                  >
                    Customers
                  </TableHead>
                  <TableHead
                    className="text-right"
                    style={{ padding: '8px 12px' }}
                  >
                    Cancelled
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {items.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={5} className="text-center py-8">
                      No coupons redeemed in this period
                    </TableCell>
                  </TableRow>
                ) : (
                  items.map((item, index) => (
                    <TableRow
                      key={item.couponUuid || index}
                      className={`hover:bg-muted/70 transition-colors ${
                        index % 2 === 0 ? 'bg-background' : 'bg-muted/20'
                      }`}
                    >
                      <TableCell style={{ padding: '8px 12px' }}>
                        <Badge variant="outline">{item.code}</Badge>
                      </TableCell>
                      <TableCell
                        className="text-right"
                        style={{ padding: '8px 12px' }}
                      >
                        {formatNumber(item.redemptionCount)}
                      </TableCell>
                      <TableCell
                        className="text-right"
                        style={{ padding: '8px 12px' }}
                      >
                        {formatCurrency(item.totalDiscount)}
                      </TableCell>
                      <TableCell
                        className="text-right"
                        style={{ padding: '8px 12px' }}
                      >
                        {formatNumber(item.uniqueCustomerCount)}
                      </TableCell>
                      <TableCell
                        className="text-right"
                        style={{ padding: '8px 12px' }}
                      >
                        {formatNumber(item.cancelledCount)}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
